<div class="navblock">
  <button (click)="createZone()" class="btnadd">{{'Add geozone'|translate}}</button>
  <app-group-filter #groupFilter></app-group-filter>
  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="nameFilter"
           (input)="onTermChange($event)"/>
  </div>
</div>
<div class="tablewrap admingeozona">
  <div class="geozona-wrap">
    <div class="geozona-table">
      <div class="table js-table" *ngIf="!isEdit">
        <table fixedcols="[0, 1, 5]" id="exporttable">
          <tr>
            <th>
                <switch-all-checkbox [items]="objects | groupFilter : filter" />
            </th>
            <th>&nbsp;</th>
            <th>{{'Name'|translate}}</th>
            <th>{{'Description'|translate}}</th>
            <th>{{'Radius'|translate}}</th>
            <th>{{'Max speed'|translate}}</th>
            <th>&nbsp;</th>
          </tr>
          <tr *ngFor="let geozone of objects | groupFilter : filter | pagesfilter: pageInfoFilter" (click)="onGeozoneSelected(geozone)">
            <td>
              <input type="checkbox" [(ngModel)]="geozone.IsChecked"/>
            </td>
            <td>
              <img src="/assets/icons/zone_point.svg" *ngIf="geozone.Style.type.toLowerCase() == 'point'">
              <img src="/assets/icons/zone_line.svg" *ngIf="geozone.Style.type.toLowerCase() == 'polyline'">
              <img src="/assets/icons/zone_polygon.svg" *ngIf="geozone.Style.type.toLowerCase() == 'polygon'">
            </td>
            <td>{{geozone.Name}}</td>
            <td>{{geozone.Comment}}</td>
            <td>{{geozone.Radius}}</td>
            <td>{{geozone.MaxSpeed}}</td>
            <td>
              <button class="btn_img btn_edit" (click)="editZone(geozone)"></button>
              <button class="btn_img btn_trush " (click)="deleteObject(geozone.Id)"></button>
            </td>
          </tr>
        </table>
      </div>
      <app-geozone-edit (zoneChange)="onZoneChanged()" [model]="selectedGeozone" [Icons]="Icons"
                        (onCreated)="Refresh()"
                        *ngIf="isEdit" (onClose)="editZone(null)"></app-geozone-edit>
    </div>
    <div (mousedown)="onSplitter()" class="ver_splitter" id="ver_right_splitter"><span></span></div>
    <div class="geozona-map">
      <simple-map (onDrawFinish)="onDrawFinish($event)"></simple-map>
    </div>
  </div>
</div>

<app-footer-component (onDeleteSelected)="deleteSelected()" [viewMode]="'print excel pages'"
                      [items]="objects | groupFilter : filter" (onPageChange)="onPageChange($event)">

  <div export style="display:inline-block">
    <div class="btn_img btn_graygray dropup btn_export-import dropclick">
      <ul>
        <li (click)="myInput.click()">
          {{'Import'|translate}}
          <input type="file" #myInput class="btn_blue" style="visibility:hidden;display: none"
                 (change)="Incomingfile(myInput.files[0])"
                 onclick="this.value=null"
                 accept=".kml,.xml">
        </li>
        <li (click)="OpenExport()">{{'Export'|translate}}</li>
      </ul>
    </div>
  </div>
</app-footer-component>
<template #groupMgmtDialog></template>
<template #objectsListDialog></template>
